import {
  ARTICLE_ID_PARAM_KEY,
  ARTICLE_PREVIEW_ID_PARAM_KEY,
} from '@candyland/angular/shared/article-tt-com/data-access';
import { ROUTE_CATEGORY_KEY, ROUTE_OVERVIEW_KEY } from '@candyland/angular/tt-com-www/overview/data-access';
import { CommonPageViewTypes } from '@candyland/angular/shared/apps-that-use-infomaker/data-access';

enum DistinctPageViewTypes {
  Discussion = 'discussion',
  Videos = 'videos',
  Gallery = 'gallery',
  Newsticker = 'newsticker',
  Dossiers = 'dossiers',
  SERP = 'SERP',
  Service = 'service',
  Piano = 'piano',
}

export const PageViewTypes = {
  ...DistinctPageViewTypes,
  ...CommonPageViewTypes,
};
export type PageViewTypes = typeof DistinctPageViewTypes & typeof CommonPageViewTypes;

export type ArticlePageTypes =
  | CommonPageViewTypes.Article
  | CommonPageViewTypes.ArticlePreview
  | DistinctPageViewTypes.Discussion
  | DistinctPageViewTypes.Videos
  | DistinctPageViewTypes.Gallery;

export const pageViewCases = [
  {
    predicate: ({
      payload: {
        routerState: { mergedData },
      },
    }) => mergedData.doNotTrack,
    pageViewType: 'no-op',
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedData },
      },
    }): boolean => mergedData.pageType === PageViewTypes.Videos,
    pageViewType: PageViewTypes.Videos,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedData },
      },
    }): boolean => mergedData.pageType === PageViewTypes.Gallery,
    pageViewType: PageViewTypes.Gallery,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedData },
      },
    }): boolean => mergedData.pageType === PageViewTypes.Discussion,
    pageViewType: PageViewTypes.Discussion,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedParams },
      },
    }): boolean => typeof mergedParams[ARTICLE_ID_PARAM_KEY] !== 'undefined',
    pageViewType: PageViewTypes.Article,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedParams },
      },
    }): boolean => typeof mergedParams[ARTICLE_PREVIEW_ID_PARAM_KEY] !== 'undefined',
    pageViewType: PageViewTypes.ArticlePreview,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedParams },
      },
    }): boolean => mergedParams[ROUTE_OVERVIEW_KEY] === 'newsticker',
    pageViewType: PageViewTypes.Newsticker,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedParams },
      },
    }): boolean =>
      mergedParams[ROUTE_OVERVIEW_KEY] === 'dossier' && typeof mergedParams[ROUTE_CATEGORY_KEY] !== 'undefined',
    pageViewType: PageViewTypes.Dossiers,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedData },
      },
    }): boolean => mergedData.pageType === PageViewTypes.Piano,
    pageViewType: PageViewTypes.Piano,
  },
  {
    predicate: ({
      payload: {
        routerState: { mergedParams },
      },
    }): boolean => typeof mergedParams[ROUTE_OVERVIEW_KEY] !== 'undefined',
    pageViewType: PageViewTypes.Overview,
  },
];
